import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import { axios } from '@/library/axios';
import type { BaseResponse } from '@/types';

import type { CustomerActiveAppointment } from './types';

const getCustomerActiveAppointment = async (customerId: string) => {
  return axios<
    CustomerActiveAppointment,
    BaseResponse<CustomerActiveAppointment>,
    void
  >({
    url: `/appointments/customers?customerId=${customerId}`,
    method: 'get',
  });
};

export const useCustomerActiveAppointment = (customerId: string) => {
  const [activeAppointment, setActiveAppointment] =
    useState<CustomerActiveAppointment>();

  const { data, isLoading } = useQuery({
    queryKey: ['active-appointment', customerId],
    queryFn: () => getCustomerActiveAppointment(customerId),
    enabled: !!customerId,
    useErrorBoundary: false,
    refetchOnWindowFocus: true,
    retry: 3,
  });

  useEffect(() => {
    const resultData = data?.data?.data;
    setActiveAppointment(resultData);
  }, [data]);

  return {
    activeAppointment,
    isLoading,
  };
};
